webpackJsonp([114276838955818,60335399758886],{

/***/ 128:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 255:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(259);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(128);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return Glamor.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),

/***/ 258:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _g$div;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _glamorous = __webpack_require__(13);
	
	var _glamorous2 = _interopRequireDefault(_glamorous);
	
	var _typography = __webpack_require__(55);
	
	var _layoutUnits = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Container = _glamorous2.default.div((_g$div = {
	  display: 'flex',
	  flexWrap: 'wrap',
	  padding: '8px 24px 24px',
	  maxWidth: '488px',
	  margin: _layoutUnits.normalMargin,
	  // borderRadius: '4px',
	  boxShadow: '0 0 0 1px ' + _typography.linkColor
	}, _g$div['@media (min-width: ' + _layoutUnits.largeBreakpoint + ')'] = {
	  margin: _layoutUnits.largeMargin
	}, _g$div));
	
	var LinkGroup = _glamorous2.default.div({
	  marginTop: '24px',
	  flex: '1 1 220px'
	});
	
	var BuyLink = function BuyLink(_ref) {
	  var url = _ref.url,
	      name = _ref.name;
	  return Glamor.createElement(
	    'div',
	    null,
	    Glamor.createElement(
	      _glamorous2.default.A,
	      {
	        display: 'inline-block',
	        lineHeight: '32px',
	        target: '_blank',
	        href: url },
	      name
	    )
	  );
	};
	
	exports.default = function () {
	  return Glamor.createElement(
	    Container,
	    null,
	    Glamor.createElement(
	      LinkGroup,
	      null,
	      Glamor.createElement(
	        _glamorous2.default.H5,
	        { margin: '0 0 8px' },
	        'Buy The Realist in the US:'
	      ),
	      Glamor.createElement(BuyLink, {
	        name: 'Amazon',
	        url: 'https://www.amazon.com/Realist-Novel-Berenice-Abbott/dp/1781327297/' }),
	      Glamor.createElement(BuyLink, {
	        name: 'Barnes & Noble',
	        url: 'https://www.barnesandnoble.com/w/the-realist-sarah-coleman/1127485817?ean=9781781327296' })
	    ),
	    Glamor.createElement(
	      LinkGroup,
	      null,
	      Glamor.createElement(
	        _glamorous2.default.H5,
	        { margin: '0 0 8px' },
	        'Buy The Realist in the UK:'
	      ),
	      Glamor.createElement(BuyLink, {
	        name: 'Amazon',
	        url: 'https://www.amazon.co.uk/Realist-Novel-Berenice-Abbott/dp/1781327297/' }),
	      Glamor.createElement(BuyLink, {
	        name: 'Waterstones',
	        url: 'https://www.waterstones.com/book/the-realist/sarah-coleman/9781781327302' })
	    )
	  );
	};
	
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),

/***/ 259:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _g$h, _g$h2;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _glamorous = __webpack_require__(13);
	
	var _glamorous2 = _interopRequireDefault(_glamorous);
	
	var _buybook = __webpack_require__(258);
	
	var _buybook2 = _interopRequireDefault(_buybook);
	
	var _typography = __webpack_require__(55);
	
	var _layoutUnits = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var maxSmallTitles = '399px';
	var maxSmallTopMargin = '511px';
	
	var Title = _glamorous2.default.h1((_g$h = {
	  flex: '0 0 auto',
	  margin: '48px 0 4px ' + _layoutUnits.normalMargin
	}, _g$h['@media (max-width: ' + maxSmallTitles + ')'] = {
	  flex: '0 0 100%',
	  fontSize: '30px'
	}, _g$h['@media (max-width: ' + maxSmallTopMargin + ')'] = {
	  marginTop: '40px'
	}, _g$h['@media (min-width: ' + _layoutUnits.largeBreakpoint + ')'] = {
	  marginLeft: _layoutUnits.largeMargin
	}, _g$h));
	
	var Subtitle = _glamorous2.default.h2((_g$h2 = {
	  flex: '0 0 auto',
	  marginLeft: _layoutUnits.normalMargin,
	  marginRight: _layoutUnits.normalMargin
	}, _g$h2['@media (max-width: ' + maxSmallTitles + ')'] = {
	  fontSize: '22px'
	}, _g$h2));
	
	exports.default = function (_ref) {
	  var children = _ref.children;
	  return Glamor.createElement(
	    _glamorous2.default.Div,
	    {
	      maxWidth: _layoutUnits.maxLayoutWidth,
	      minHeight: '100vh',
	      overflow: 'hidden',
	      margin: '0 auto',
	      paddingBottom: '40px',
	      boxShadow: 'inset 0 1px 0 0 ' + _typography.linkColor },
	    Glamor.createElement(
	      _glamorous2.default.Div,
	      {
	        display: 'flex',
	        justifyContent: 'flex-start',
	        flexWrap: 'wrap',
	        alignItems: 'baseline' },
	      Glamor.createElement(
	        Title,
	        null,
	        'Sarah Coleman'
	      ),
	      Glamor.createElement(
	        Subtitle,
	        null,
	        'Writer'
	      )
	    ),
	    Glamor.createElement(
	      'div',
	      null,
	      children()
	    ),
	    Glamor.createElement(_buybook2.default, null)
	  );
	};
	
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-f84aa6cd279b41b8c967.js